import { render, staticRenderFns } from "./deduction_rules.vue?vue&type=template&id=7c84a128&scoped=true"
import script from "./deduction_rules.vue?vue&type=script&lang=js"
export * from "./deduction_rules.vue?vue&type=script&lang=js"
import style0 from "./deduction_rules.vue?vue&type=style&index=0&id=7c84a128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c84a128",
  null
  
)

export default component.exports